// extracted by mini-css-extract-plugin
export default {"LeadTitle":"LeadTitle-module-ad860681a2ae14e54dcb","title":"LeadTitle-module-fed9bf4b8d837f79c316","time":"LeadTitle-module-cb21dd9c90fd3eeceade"};